export const gtmViewItemListEvent = (productGtmData: any, designIds: string[]) => {
  const impressions: any[] = [];
  designIds.forEach((designId) =>
    impressions.push({
      id: productGtmData[designId].id,
      family_id: null, // ?????
      name: productGtmData[designId].name,
      publicDesignId: productGtmData[designId].publicDesignId,
      customerDesignId: productGtmData[designId].customerDesignId,
      brand: productGtmData[designId].brand,
      category: productGtmData[designId].category,
      marketing_material: productGtmData[designId].marketing_material,
      price: productGtmData[designId].price,
      dimension1: productGtmData[designId].dimension1,
      dimension2: productGtmData[designId].dimension2,
      dimension3: productGtmData[designId].dimension3,
      list: 'Search Page',
    }),
  );
  return {
    event: 'view_item_list',
    ecommerce: {
      currencyCode: 'NOK', /// ????
      impressions,
    },
  };
};

export default gtmViewItemListEvent;
